import React from 'react'
import Svg from './Svg';
import { defaultGrey } from '../../prop-types';

interface ICheck{
  color?: string
}
export default function Check({color = defaultGrey}: ICheck):  any {
  return (
    <Svg
      xmlns={"http://www.w3.org/2000/svg"}
      paths={[
        { fill:"none", d:"M0 0h24v24H0V0z" },
        {  fill: color, d:"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"},
      ]}
    />
  )
}



